<template>
  <div class="content-page">
    <top-bar :topbarList="topbarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
export default {
  data() {
    return {};
  },
  components: {
    topBar,
  },
  computed: {
    topbarList() {
      let topbarList = [
        {
          name: "排班管理",
          isActive: false,
          path: "/craftsman/schedule/manage",
        },
        {
          name: "班次管理",
          isActive: false,
          path: "/craftsman/schedule/shiftManage",
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
};
</script>
